import { IFormField, IFormSection } from "../../../../../shared/components/web-form/web-form.objects";
import _ from "lodash";

export class ExternalColabField {
    fieldId: string;
    displayName: string;
    isRequired: boolean;
    propertyName: string;
    defaultVal: any;

    formSection: IFormSection;
    forObjProperty: boolean = true;
    shouldTriggerUpdate: boolean = false;

    controllingDropdownSelector: string;
    showWhenValue: string;
    blockSelector: string;

    constructor(
        propertyName: string,
        defaultVal: any,
        fieldId: string,
        displayName: string,
        isRequired: boolean,
        controllingDropdownSelector: string,
        showWhenValue: string,
        blockSelector: string
    ) {
        this.propertyName = propertyName;
        this.defaultVal = defaultVal;
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.isRequired = isRequired;

        this.controllingDropdownSelector = controllingDropdownSelector;
        this.showWhenValue = showWhenValue;
        this.blockSelector = blockSelector;
    }

    initialize(formSection: IFormSection) {
        this.formSection = formSection;

        $(this.controllingDropdownSelector).on("changed.bs.select change", () => {
            this.toggleTextbox();
            this.triggerSectionUpdate();
        });

        this.toggleTextbox();
    }

    private toggleTextbox() {
        const dropdownVal = String($(this.controllingDropdownSelector).val());

        if (dropdownVal === this.showWhenValue) {
            $(this.blockSelector).removeClass("d-none");
        } else {
            $(this.blockSelector).addClass("d-none");
            $(`#${this.fieldId}`).val("");
        }
    }

    private getInput(): string {
        return (<string>$(`#${this.fieldId}`).val())?.trim();
    }

    getValue(): any {
        return this.checkValid() ? this.getInput() : this.defaultVal;
    }

    setValue(formData: any) {
        const val = _.get(formData, this.propertyName);
        if (val !== undefined) {
            $(`#${this.fieldId}`).val(val);
        }
    }

    checkValid(): boolean {
        const dropdownVal = String($(this.controllingDropdownSelector).val());
        const inputVal = this.getInput();

        if (dropdownVal === this.showWhenValue) {
            return !!inputVal;
        }
        return true;
    }

    checkChanged(): boolean {
        return this.getInput() !== this.defaultVal;
    }

    displayValid(isValid: boolean) {
        $(`#${this.fieldId}`)
            .toggleClass("is-valid", isValid)
            .toggleClass("is-invalid", !isValid);
    }

    resetValidDisplay() {
        $(`#${this.fieldId}`).removeClass("is-valid is-invalid");
    }

    triggerSectionUpdate() {
        if (this.formSection && this.shouldTriggerUpdate) {
            this.formSection.updateSection();
        }
    }
}
